import React from 'react'
import PropTypes from 'prop-types'

const EmergencyIcon = (props) => {
  const { width = 20, height = 20, fill = '#183560' } = props
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2176_2230)">
        <path
          d="M10 5.90182L15.4764 15.3636H4.52364L10 5.90182ZM10 3L2 16.8182H18L10 3ZM10.7273 13.1818H9.27273V14.6364H10.7273V13.1818ZM10.7273 8.81818H9.27273V11.7273H10.7273V8.81818Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2176_2230">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

EmergencyIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default EmergencyIcon
